import React, { useState, useEffect } from "react";

import { BrowserRouter } from "react-router-dom";
import { QueryClient } from "@tanstack/react-query";

import AppSignalWrapper from "./global/AppSignalWrapper.jsx";
import { AppContextProvider } from "./global/appContext.jsx";
import ReactQueryClientProvider from "./global/queryClientProvider.jsx";
import PolarisProvider from "./global/polarisProvider.jsx";
import AppBridgeProvider from "./global/appBridgeProvider.jsx";
import AppWrapper from "./global/appWrapper.jsx";
import AppRoutes from "./global/AppRoutes.jsx";
import AppNavMenu from "./global/NavMenu.jsx";

// Initialize i18n
import "./global/i18n";
import i18n from "./global/i18n";

// Debug Translator Switcher Component


export default function App(props) {
  // Initialize i18n with Shopify locale detection
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const locale = urlParams.get('locale');
    
   // if (locale && locale !== i18n.language) {
    //  i18n.changeLanguage(locale);
   // }
  }, []);

  // App Bridge v4: Use shopify.toast.show() instead of Polaris Toast
  async function setMessage(content, error = false) {
    if (window.shopify?.toast) {
      try {
        await window.shopify.toast.show(content, {
          duration: error ? 5000 : 2500,
          isError: error
        });
      } catch (e) {
        console.error("[App] Failed to show toast:", e);
        // Fallback to console if toast fails
        console.log(error ? `Error: ${content}` : content);
      }
    } else {
      console.log(error ? `Error: ${content}` : content);
    }
  }

  return (
    <PolarisProvider>
      <AppSignalWrapper>
        <BrowserRouter>
          <AppContextProvider {...props} {...{ setMessage }}>
            <ReactQueryClientProvider showDevTools={!props.production}>
              <AppBridgeProvider>
                <AppNavMenu />
                <AppWrapper>
                  <AppRoutes />
                </AppWrapper>
              </AppBridgeProvider>
            </ReactQueryClientProvider>
          </AppContextProvider>
        </BrowserRouter>
      </AppSignalWrapper>
    </PolarisProvider>
  );
}

// import Appsignal from "@appsignal/javascript";
// import { ErrorBoundary } from "@appsignal/react";

// const FallbackComponent = () => <div>Uh oh! There was an error :(</div>;
// const appsignal = new Appsignal({
//   active: true,
//   key: "b3a23111-e61a-4567-94af-043674495ed7",
// });
// <ErrorBoundary
//   instance={appsignal}
//   debug={true}
//   // tags={{ tag: "value" }}
//   fallback={(error) => <FallbackComponent />}
// >
//   ...Code here...
// </ErrorBoundary>;
